<template>
  <t-form>
    <t-form-item :label="option.attribute.showLable?option.attribute.label:''">
      <!-- <t-space>  :href="'tel:' + cptData.value"-->
        <div :size="option.attribute.size" style="display:inline-block" @click="callPhone">
          <span v-if="option.attribute.showPhone" :style="{ color: option.attribute.textColor}">{{cptData.value}}</span>
          <div style="cursor: pointer;position:relative;display: inline-block;" :style="{
            animation: option.attribute.autoRotate ? 'rotate ' + option.attribute.rotateDuration + 's infinite linear': null,
            width: option.attribute.width + 'px',height: option.attribute.height + 'px',left:option.attribute.left + 'px'}">
            <t-image style="width: 100%; height: 100%; z-index: 0;" :style="{ background: option.attribute.bgColor || 'none' }"
              :src="option.attribute.url ? fileUrl + option.attribute.url : require('@/assets/custom/phone.png')" 
              :fit="option.attribute.fit"/>
          </div>
        </div>
      <!-- </t-space> -->
    </t-form-item>
  </t-form>
</template>

<script>
import { getDataJson,pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import { fileUrl } from '/env'
import { WeChat } from '@/views/viewsFunction/designerMethods'
export default {
  name: "cpt-phone",
  props:{ option:Object,height:Number,current: Object,cacheComponents: Array,components:Array },
  data() {
    return {
      cptData: {},
      uuid: null,
      newData: "",
      jsFunFlag: false,
      isMobile:false,
      fileUrl,
    }
  },
  computed:{
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  mounted() {
    console.log(/Mobi|Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry|BB10|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent),'**')
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods:{
    // handleClick(event) {
    //   if (!this.isMobile) {
    //     event.preventDefault();
    //   }
    // },
    refreshCptData(cptDataForm = this.option.cptDataForm, paras){
      pollingRefresh(this.uuid, cptDataForm, ()=>this.loadData(cptDataForm,paras))
    },
    loadData(cptDataForm,paras){
      const that = this;
      getDataJson(cptDataForm,paras,(res)=> {
        that.newData = cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction") ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction") ? res.jsFunction : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      })
    },
    processData(cptDataForm, res, jsFunFlag,isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
       if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 
        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.cptData = newres[0];
          }
        } else {
          // 如果配置了转换脚本
          this.cptData = res;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.cptData = this.newData;
      }
    },
    callPhone() {
       this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
       this.init(this.cptData.value)
    },
    init(val) {
      console.log('wagaaaaa')
      // 使用原生h5拨打电话
      // window.location.href = 'tel:' + val;
      let num = Number(val);
      let isMiniProgram = /MicroMessenger/i.test(navigator.userAgent);
      if(isMiniProgram) {
        WeChat.MakePhoneCall({
          phoneNumber: num
        })
        return;
      }
      let isAndroid = /android/i.test(navigator.userAgent);
      isAndroid ? window.Android.callPhone(num) : null;
      
      
    }
  }
}
</script>
<style scoped>
:deep(.t-link--theme-default.t-link--hover-underline:after) {
  border-bottom:0px !important;
}
a {
  text-decoration: none;
  display:flex;
  flex-direction: row;
}
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
</style>